import React from 'react';

const CardCloseSVG = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6875 1.3125L1.3125 12.6875M1.3125 1.3125L12.6875 12.6875"
      stroke="#999999"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PlusIconSVG = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="32" cy="32" r="32" fill="#E2E2E2" />
    <g opacity="0.8">
      <path
        d="M33 40V32M33 32V24M33 32H41M33 32H25"
        stroke="#818285"
        strokeWidth="6"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export { CardCloseSVG, PlusIconSVG };
